import { useAsync } from './components/common';
import { api } from './session';

/** Names for operators that another service recorded by their AUTH user id (buddy3's provisioning runs keep the token's
 *  `sub`): id → name from the hub's audit log (`GET /operators/names`). Ids it does not know are absent, and a failed
 *  lookup leaves every id as it is. */
export function useOperatorNames(ids: readonly string[] | undefined): Record<string, string> {
  const key = [...new Set(ids ?? [])].filter(Boolean).sort().join('\n');
  const names = useAsync(
    () => (key ? api.operatorNames(key.split('\n')).catch(() => ({})) : Promise.resolve({})),
    [key]
  );
  return names.data ?? {};
}
